/**
 * Home Hero – particle sphere + transfer particles + text swapper
 */

const PHRASES = [
	'Import, Export & Sync',
	'Bulk Content Updates',
	'Media Folder Sync',
	'AI URL Importing',
	'Site-to-Site Sync',
	'User Data Sync',
];

const TRANSFER_ICONS  = [ 'article', 'shopping_cart', 'person', 'image', 'database', 'attachment' ];
const PARTICLE_COLORS = [ '#a855f7', '#6366f1', '#06b6d4' ];
const TRANSFER_ICON_PATHS = {
	article: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 14H7v-2h10v2zm0-4H7v-2h10v2zm0-4H7V7h10v2z',
	attachment: 'M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.1.9 2 2 2s2-.9 2-2V5c0-1.93-1.57-3.5-3.5-3.5S7 3.07 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z',
	database: 'M12 3C7.58 3 4 4.34 4 6v12c0 1.66 3.58 3 8 3s8-1.34 8-3V6c0-1.66-3.58-3-8-3zm0 2c3.31 0 6 .9 6 2s-2.69 2-6 2-6-.9-6-2 2.69-2 6-2zm0 14c-3.31 0-6-.9-6-2v-2c1.42 1.03 3.7 1.5 6 1.5s4.58-.47 6-1.5v2c0 1.1-2.69 2-6 2zm0-4.5c-3.31 0-6-.9-6-2v-2c1.42 1.03 3.7 1.5 6 1.5s4.58-.47 6-1.5v2c0 1.1-2.69 2-6 2z',
	image: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z',
	person: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
	shopping_cart: 'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45C5.09 14.32 5 14.65 5 15c0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03L20.88 5H5.21l-.94-2H1z',
};

// ── Text swapper ─────────────────────────────────────────────────
function initSwapper() {
	const swapper = document.getElementById( 'hero-swapper-inner' );
	if ( ! swapper ) return;

	let currentIdx = 0;
	let interval;

	function build() {
		if ( window.innerWidth < 768 ) {
			swapper.innerHTML = '<span>Site-to-Site Sync</span>';
			swapper.style.transform = 'translateY(0)';
			clearInterval( interval );
			return;
		}

		swapper.innerHTML = PHRASES.map( p => `<span>${ p }</span>` ).join( '' );
		currentIdx = 0;
		swapper.style.transform = 'translateY(0)';
		clearInterval( interval );
		interval = setInterval( rotate, 3500 );
	}

	function rotate() {
		if ( window.innerWidth < 768 ) return;
		currentIdx = ( currentIdx + 1 ) % PHRASES.length;
		swapper.style.transform = `translateY(-${ currentIdx * 1.2 }em)`;
	}

	build();

	let resizeTimer;
	window.addEventListener( 'resize', () => {
		clearTimeout( resizeTimer );
		resizeTimer = setTimeout( build, 250 );
	} );
}

// ── Particle sphere (canvas) ──────────────────────────────────────
function initSphere() {
	const canvas = document.getElementById( 'hero-canvas' );
	if ( ! canvas || window.innerWidth < 1024 ) return;

	const ctx    = canvas.getContext( '2d' );
	const NUM    = 180;
	const RADIUS = 155;
	const dots   = [];

	function resize() {
		const rect  = canvas.parentElement.getBoundingClientRect();
		canvas.width  = rect.width;
		canvas.height = rect.height;
	}

	class Dot {
		constructor( i ) {
			this.phi   = Math.acos( -1 + ( 2 * i ) / NUM );
			this.theta = Math.sqrt( NUM * Math.PI ) * this.phi;
			this.x     = RADIUS * Math.cos( this.theta ) * Math.sin( this.phi );
			this.y     = RADIUS * Math.sin( this.theta ) * Math.sin( this.phi );
			this.z     = RADIUS * Math.cos( this.phi );
			this.size  = 1.5 + Math.random() * 2;
		}

		draw( t ) {
			const ry = t * 0.0003;
			const rx = t * 0.00015;

			const x1 = this.x * Math.cos( ry ) - this.z * Math.sin( ry );
			const z1 = this.x * Math.sin( ry ) + this.z * Math.cos( ry );
			const y2 = this.y * Math.cos( rx ) - z1  * Math.sin( rx );
			const z2 = this.y * Math.sin( rx ) + z1  * Math.cos( rx );

			const p  = 500 / ( 500 + z2 );
			const sx = x1 * p + canvas.width  / 2;
			const sy = y2 * p + canvas.height / 2;
			const op = ( z2 + RADIUS ) / ( RADIUS * 2 );

			ctx.beginPath();
			ctx.arc( sx, sy, this.size * p, 0, Math.PI * 2 );
			ctx.fillStyle = `rgba(229, 226, 225, ${ 0.1 + op * 0.4 })`;
			ctx.fill();
		}
	}

	for ( let i = 0; i < NUM; i++ ) dots.push( new Dot( i ) );

	function animate( t ) {
		ctx.clearRect( 0, 0, canvas.width, canvas.height );
		dots.forEach( d => d.draw( t ) );
		requestAnimationFrame( animate );
	}

	let resizeFrame = false;
	const scheduleResize = () => {
		if ( resizeFrame ) return;
		resizeFrame = true;
		window.requestAnimationFrame( () => {
			resize();
			resizeFrame = false;
		} );
	};

	scheduleResize();
	animate( 0 );
	window.addEventListener( 'resize', scheduleResize, { passive: true } );
}

// ── Transfer particles ────────────────────────────────────────────
function initParticles() {
	const container = document.getElementById( 'hero-particles' );
	if ( ! container || window.innerWidth < 1024 ) return;

	function spawn() {
		const el    = document.createElement( 'div' );
		el.style.cssText = 'position:absolute;z-index:30;display:flex;align-items:center;justify-content:center;';

		const icon  = TRANSFER_ICONS[ Math.floor( Math.random() * TRANSFER_ICONS.length ) ];
		const color = PARTICLE_COLORS[ Math.floor( Math.random() * PARTICLE_COLORS.length ) ];
		const size  = 28 + Math.random() * 20;

		el.innerHTML = `<span class="material-symbols-outlined" aria-hidden="true" style="font-size:${ size }px;color:${ color };font-variation-settings:'FILL' 0,'wght' 400,'GRAD' 0,'opsz' 24;filter:drop-shadow(0 0 8px ${ color });">${ icon }</span>`;
		container.appendChild( el );

		const dur = 2500 + Math.random() * 1500;

		const anim = el.animate( [
			{ offsetDistance: '0%',   opacity: 0, transform: 'scale(0.5)' },
			{ offsetDistance: '15%',  opacity: 1, transform: 'scale(1)' },
			{ offsetDistance: '85%',  opacity: 1, transform: 'scale(1)' },
			{ offsetDistance: '100%', opacity: 0, transform: 'scale(0.5)' },
		], { duration: dur, easing: 'cubic-bezier(0.4,0,0.2,1)' } );

		el.style.offsetPath   = "path('M 70,250 Q 280,50 490,250')";
		el.style.offsetRotate = '0deg';

		anim.onfinish = () => el.remove();
	}

	const start = () => setInterval( spawn, 850 );
	if ( document.fonts?.load ) {
		document.fonts.load( '400 32px "Material Symbols Outlined"', 'attachment' )
			.then( start )
			.catch( start );
	} else {
		start();
	}
}

// ── Feature cards backlight ───────────────────────────────────────
function initFeatureCards() {
	document.querySelectorAll( '.feature-card' ).forEach( card => {
		card.addEventListener( 'mousemove', ( e ) => {
			const rect = card.getBoundingClientRect();
			const x = ( ( e.clientX - rect.left ) / rect.width ) * 100;
			const y = ( ( e.clientY - rect.top ) / rect.height ) * 100;
			card.style.setProperty( '--mouse-x', `${ x }%` );
			card.style.setProperty( '--mouse-y', `${ y }%` );
		} );
	} );
}

// ── Init ──────────────────────────────────────────────────────────
export default function initHero() {
	initSwapper();
	initSphere();
	initParticles();
	initFeatureCards();
}
